import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StateService {
  private componentState: any = {};

  setState(key: string, state: any) {
    this.componentState[key] = state;
  }

  getState(key: string): any {
    return this.componentState[key];
  }
}
